import { HttpContextToken } from '@angular/common/http';

/**
 * Opt-out flag for the global loading overlay.
 *
 * Usage:
 *   this.http.get(url, { context: new HttpContext().set(SKIP_LOADING, true) })
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);
